import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  DiskBackupDateContentsResponse,
  fetchDiskBackupDateContents,
} from "../../../api/admin";
import { useAuthStore } from "../../../atoms/user.auth.store";
import ContentsTopHeader from "../../../components/common/contents.top.header";
import {
  BackupContainer,
  ContentsBody,
} from "../../../style/contents/backup/backup";

const getUserAccount = () => {
  const userInfo = localStorage.getItem("userInfo");
  if (!userInfo) return "";

  try {
    const parsed = JSON.parse(userInfo);
    return parsed.userAccount || "";
  } catch {
    return "";
  }
};

const BackupDateSelect = () => {
  const { role } = useAuthStore();
  const [data, setData] = useState<DiskBackupDateContentsResponse | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { path: rawDeviceId = "" } = useParams<{ path: string }>();
  const deviceId = decodeURIComponent(rawDeviceId);
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id");
  const queryUserAccount = queryParams.get("userAccount");
  const rootDirectoryPath = queryParams.get("rootDirectoryPath");
  const userAccount =
    role === "user" ? getUserAccount() || queryUserAccount : queryUserAccount;
  const isAdmin = role === "admin";
  const filteredRootBackupDates =
    data?.rootBackupDates.filter(
      (item) => item.rootDirectoryPath === rootDirectoryPath,
    ) || [];

  const handleSearch = () => {
    // TODO: fetchData(keyword, pageSize);
  };

  const handlePageSizeChange = () => {};

  const handleBackupDateClick = (
    rootDirectoryPath: string,
    backupDate: string,
  ) => {
    const encodedRootDirectoryPath = encodeURIComponent(rootDirectoryPath);
    const nextQueryParams = new URLSearchParams(location.search);

    nextQueryParams.set("deviceId", deviceId);
    nextQueryParams.set("backupDate", backupDate);

    localStorage.setItem(
      "directory",
      JSON.stringify({
        directoryPath: rootDirectoryPath,
        createDate: backupDate,
      }),
    );
    localStorage.setItem("initialPath", rootDirectoryPath);

    navigate(
      `/backup/file/list/${encodedRootDirectoryPath}?${nextQueryParams.toString()}`,
    );
  };

  useEffect(() => {
    if (!deviceId || !userId || !userAccount) return;

    const loadBackupDateContents = async () => {
      try {
        setIsLoading(true);
        const response = await fetchDiskBackupDateContents({
          deviceId,
          userId: Number(userId),
          userAccount,
          isAdmin,
        });
        setData(response);
      } catch {
        setData(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadBackupDateContents();
  }, [deviceId, isAdmin, userAccount, userId]);

  return (
    <BackupContainer>
      <ContentsTopHeader
        title="백업 날짜 선택"
        onSearch={handleSearch}
        onPageSizeChange={handlePageSizeChange}
        pageSizeHidden={true}
      />
      <ContentsBody>
        {isLoading ? (
          <p>불러오는 중입니다.</p>
        ) : filteredRootBackupDates.length === 0 ? (
          <p className="no-data">백업 날짜가 없습니다.</p>
        ) : (
          <div className="backup-date-list">
            {filteredRootBackupDates.map((rootBackupDate) => (
              <div
                className="backup-date-root"
                key={rootBackupDate.rootDirectoryPath}
              >
                <div className="top-components">
                  <div className="l">
                    <label>{rootBackupDate.rootDirectoryPath}</label>
                  </div>
                </div>
                <div className="hr"></div>
                {rootBackupDate.backupDates.map((backupDate) => (
                  <button
                    type="button"
                    className="backup-date-item"
                    key={backupDate.backupDate}
                    onClick={() =>
                      handleBackupDateClick(
                        rootBackupDate.rootDirectoryPath,
                        backupDate.backupDate,
                      )
                    }
                  >
                    <p>{backupDate.backupDate}</p>
                    <span>파일 {backupDate.fileCount}개</span>
                  </button>
                ))}
              </div>
            ))}
          </div>
        )}
      </ContentsBody>
    </BackupContainer>
  );
};

export default BackupDateSelect;
